<template>
	<inertia-head title="Login" />
	<h5 v-if="authAdmin" class="text-center">
		<mark>
			<i class="fa fa-user-lock me-2"></i>
			Administrator Login
		</mark>
	</h5>
	<form @submit.prevent="login" autocomplete="off">
		<!-- <div class="form-floating mb-4">
			<input
				v-model="form.dev_pass"
				:class="{ 'is-invalid': form.errors.dev_pass }"
				type="text"
				class="form-control"
				id="dev_pass"
				placeholder="Enter your DEV PASS"
				autofocus
			/>
			<label class="form-label" for="dev_pass">DEV PASS</label>
			<div v-if="form.errors.dev_pass" class="invalid-feedback">
				<i class="fa fa-exclamation-circle"></i>
				{{ form.errors.dev_pass }}
			</div>
		</div> -->
		<div v-if="authAdmin" class="form-floating mb-4">
			<input
				v-model="form.username"
				:class="{ 'is-invalid': form.errors.username }"
				type="text"
				class="form-control"
				id="username"
				placeholder="Enter your username"
				autofocus
			/>
			<label class="form-label" for="username">Username</label>
			<div v-if="form.errors.username" class="invalid-feedback">
				<i class="fa fa-exclamation-circle"></i>
				{{ form.errors.username }}
			</div>
		</div>
		<div v-else>
			<div class="form-floating mb-4">
				<input
					v-model="form.email"
					:class="{ 'is-invalid': form.errors.email }"
					type="text"
					class="form-control"
					id="email"
					placeholder="Enter your email"
					autofocus
				/>
				<label class="form-label" for="email">Email address</label>
				<div v-if="form.errors.email" class="invalid-feedback">
					<i class="fa fa-exclamation-circle"></i>
					{{ form.errors.email }}
				</div>
			</div>
		</div>
		<div class="form-floating mb-4">
			<input
				v-model="form.password"
				:class="{ 'is-invalid': form.errors.password }"
				type="password"
				class="form-control"
				id="password"
				placeholder="Enter your password"
			/>
			<label class="form-label" for="password">Password</label>
			<div v-if="form.errors.password" class="invalid-feedback">
				<i class="fa fa-exclamation-circle"></i>
				{{ form.errors.password }}
			</div>
		</div>
		<div v-if="flash" class="mb-4 text-center">
			<p class="mb-0 fw-semibold text-pulse">
				{{ flash.message }}
			</p>
		</div>
		<div class="row g-sm mb-4">
			<div class="col-12 mb-2">
				<button
					:disabled="form.processing"
					type="submit"
					class="btn btn-lg btn-alt-primary w-100 py-3 fw-semibold"
					data-toggle="click-ripple"
				>
					<span v-if="!form.processing">Sign in</span>
					<span v-else>
						<div class="spinner-border spinner-border-sm text-dark" role="status" >
							<span class="sr-only mr-1">Please wait...</span>
						</div>
						<span class="mx-2">Please wait...</span>
					</span>
				</button>
			</div>
			<div v-if="!form.processing || form.error" class="col-sm-6 mb-1">
				<inertia-link
					:href="route('checkout.index')"
					class="btn btn-alt-secondary w-100"
				>
					New Account
				</inertia-link>
			</div>
			<div v-if="!form.processing || form.error" class="col-sm-6 mb-1">
				<inertia-link
					:href="route('reset-password')"
					class="btn btn-alt-secondary w-100"
				>
					Reset password
				</inertia-link>
			</div>
		</div>
	</form>
</template>

<script>
import { useForm } from '@inertiajs/inertia-vue3'
import GuestLayout from '../../Layouts/GuestLayout'

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

export default {
	layout: GuestLayout,
	props: {
		flash: Object,
		redirect : String,
		authAdmin: Boolean,
	},
	setup(props) {
		const form = useForm({
			// dev_pass: null,
			email: null,
			username: null,
			password: null,
			redirect: props.redirect,
			authAdmin: props.authAdmin,
		})

		const login = () => {
			form.processing = true
			const url = props.authAdmin ? '/post/admin-login' : '/post/member-login'

			setTimeout(() => form.post(url, { preserveScroll: true }), 500)
		}

		return {
			form,
			login,
		}
	},
}
</script>
